import i18n from 'i18next';

const getDecimalSeparator = (language: string) =>
  new Intl.NumberFormat(language)
    .formatToParts(1.1)
    .find(({ type }) => type === 'decimal')?.value ?? '.';

// Swaps the "." of a stored decimal string for the locale's separator ("25.322" →
// "25,322" in French). Works on the string rather than a parsed float so the
// digits are shown exactly as stored — no rounding, no float artefacts.
export default function formatDecimalString(
  value: string | number,
  language: string = i18n.language || 'en',
): string {
  return `${value}`.replace('.', getDecimalSeparator(language));
}
